export default __webpack_public_path__ + "static/media/puddle.0f044e42.png";